export const calculateScore = (requestingPositions, otherPositions) => {
  try {
    if (!Array.isArray(requestingPositions) || !Array.isArray(otherPositions)) return 0;
    if (requestingPositions.length !== 6 || otherPositions.length !== 6) return 0;

    let sumOfSquaredDisplacements = 0;
    for (let i = 0; i < 6; i += 1) {
      const item = requestingPositions[i];
      const otherIndex = otherPositions.indexOf(item);
      if (otherIndex === -1) continue;
      const displacement = Math.abs(i - otherIndex);
      sumOfSquaredDisplacements += displacement * displacement;
    }

    const base = 70 - sumOfSquaredDisplacements;
    let bonus = 0;
    if (requestingPositions[0] === otherPositions[0]) bonus += 3;
    if (requestingPositions[5] === otherPositions[5]) bonus += 2;
    let total = base + bonus;
    if (total < 0) total = 0;
    if (total > 75) total = 75;
    return Math.trunc(total);
  } catch (_) {
    return 0;
  }
};

export const getScoreText = (score, isCurrentUser) => {
  if (isCurrentUser) return { text: 'me', color: '#6c757d' };
  if (typeof score !== 'number') return null;
  const pctStr = ((score / 75) * 100).toFixed(1) + '%';
  const withPct = (label) => `${label} [${pctStr}]`;
  if (score > 74) return { text: withPct('Besties!'), color: '#28a745' };
  if (score > 70) return { text: withPct('Inner Circle'), color: '#28a745' };
  if (score > 65) return { text: withPct('Vibe Tribe'), color: '#17a2b8' };
  if (score > 59) return { text: withPct('Keeps me Honest'), color: '#007bff' };
  if (score > 52) return { text: withPct('Plus One'), color: '#007bff' };
  if (score > 44) return { text: withPct('Hey Buddy'), color: '#ffc107' };
  if (score > 35) return { text: withPct('Sorta Friends tm'), color: '#fd7e14' };
  if (score > 25) return { text: withPct('Stranger Danger'), color: '#dc3545' };
  if (score > 14) return { text: withPct('Friendemy'), color: '#dc3545' };
  return { text: withPct('Nemesis'), color: '#dc3545' };
};


